import {mapFilters} from "@/utils/helpers";

const initState = () => ({
  total: 0,
  totalSC : 0,
  subTotal : 0,
  subTotalSC: 0,
  taxPrice : 0,
  taxPriceSC :0,
  appliedAmount: 0,
  paymentMethod: null,
  customerBalances: [],
  saleReports: [],
  salesByItemsReports: [],
  createdRepairOrderID : 0,
  shippingMethod: null,
  orderCreatingInProgress: false,
})

export const state = initState

export const getters = {
  getSubTotal: (state) => state.subTotal,
}
export const mutations ={
  setSubTotal(state, {subTotal}) {
    state.subTotal = subTotal;
  },
  setSubTotalSC(state, {subTotalSC}){
    state.subTotalSC = subTotalSC;
  },
  setPaymentMethod(state, {paymentMethod}) {
    state.paymentMethod = paymentMethod;
  },
  setTaxPrice(state, {taxPrice}){
    state.taxPrice = taxPrice;
  },
  setTaxPriceSC(state, {taxPriceSC}){
    state.taxPriceSC = taxPriceSC;
  },
  setTotal(state, {total}){
    state.total = total
  },
  setTotalSC(state, {totalSC}) {
    state.totalSC = totalSC
  },
  setAppliedAmount(state, {appliedAmount}) {
    state.appliedAmount = appliedAmount;
  },
  resetStoreData(state){
    state.total = 0;
    state.totalSC = 0;
    state.subTotal = 0;
    state.subTotalSC = 0;
    state.paymentMethod = null;
    state.shippingMethod = null;
  },
  updateCreatedRepairOrderID(state, newID){
    state.createdRepairOrderID = newID;
  },
  setShippingMethod(state, shippingMethod){
    state.shippingMethod = shippingMethod;
  },
  setOrderCreatingInProgress(state, inProgress){
    state.orderCreatingInProgress = inProgress
  },
}

export const actions ={

  async fetchRepairsListItems({commit, dispatch}, {filters, pagingInfo, showClosedTickets}){
    let repairsListItems = []
    try{
      let filter = mapFilters(filters,pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      filter.showClosedTickets = showClosedTickets;
      let result = await this.$axios.$get(`webpos/repairs?${new URLSearchParams(filter).toString()}`);
      if (result && !result.hasErrors) {
        repairsListItems = result;
      }
      else{
        this.$toast.error("Error while getting repair items.");
      }
    }
    catch{
      this.$toast.error("Error while getting repair items.");
    }
    return repairsListItems;
  },

  async createWebPOSRepairJobOrder({commit}, {orderData}){
    try {
      commit('setOrderCreatingInProgress', true)
      const response = await this.$axios.$post(`/webpos/repair-job-order/create`, orderData);
      if(response && !response.status){
        commit('updateCreatedRepairOrderID', response.newID);
        return response;
      }
      else{
        this.$toast.error('Error while creating repair job order.');
      }
    }
    catch(error){
      if(error.response && error.response.data && error.response.data.Message){
        this.$toast.error(error.response.data.Message);
        return;
      }
      this.$toast.error('Error while creating repair job order.');
    }
    finally{
      commit('setOrderCreatingInProgress', false);
    }
  },

  async createWebPOSRepairPriceQuote({commit}, {orderData}){
    try {
      commit('setOrderCreatingInProgress', true)
      const response = await this.$axios.$post(`/webpos/repair-price-quote/create`, orderData);
      if(response && !response.status){
        commit('updateCreatedRepairOrderID', response.newID);
        return response;
      }
      else{
        this.$toast.error('Error while creating repair price quote.');
      }
    }catch(error){
      if(error.response && error.response.data && error.response.data.Message){
        this.$toast.error(error.response.data.Message);
        return;
      }
      this.$toast.error('Error while creating repair price quote.');
      commit('setOrderCreatingInProgress', false);
    }
    finally {
      commit('setOrderCreatingInProgress', false);
    }
  },

  async getInitialRepairOrderData({}){
    let initialData = null;
    try{
      const result = await this.$axios.$get(
        `/webpos/repairs/initial-data`);

      if(result && !result.hasErrors){
        initialData = result.value;
      }

      else{
        this.$toast.error('Error while initializing repair order data');
      }
    }
    catch(e){
      this.$toast.error('Error while initializing repair order data');
    }
    return initialData;
  }
}
